<template>
    <ServiceAgreement />
</template>

<script setup>
import {
    // inject,
    onBeforeMount,
    onMounted,
    onUpdated,
    onUnmounted
} from "vue";
// import { router } from "../routes/router";
// import { useI18n } from "vue-i18n";
import { faLog } from "../common/faCommon.js";
import ServiceAgreement from "../components/ServiceAgreement.vue";

// const { t } = useI18n();

/**
 * VUE.js Methods...
 */
onBeforeMount(() => {
    faLog(0, "[ServiceAgreementView] [onBeforeMount]");
});

onMounted(() => {
    faLog(0, "[ServiceAgreementView] [onMounted]");
});

onUpdated(() => {
    faLog(0, "[ServiceAgreementView] [onUpdated]");
});

onUnmounted(() => {
    faLog(0, "[ServiceAgreementView] [onUnmounted]");
});
</script>
